const config = {
    controls: true,
    myGui: false
}

export default config